var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fhiry-page"},[_c('header',{staticClass:"fhiry-page-header"},[_c('fhiry-carousel',{attrs:{"data":_vm.banners}})],1),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }